// АВТОГЕНЕРИРОВАННЫЙ ФАЙЛ — НЕ РЕДАКТИРУЙТЕ ВРУЧНУЮ.
// Источник правды: data-source/korpy_balance_v6.xlsx
// Регенерация: npm run gen-cards (или двойной клик по tools/gen-cards.bat)
// Сгенерировано: 2026-06-03T21:08:21.157Z

export const cards = [
  {
    "id": "global_act_boevaya_vyuchka",
    "name_ru": "Боевая выучка",
    "name_en": "Combat Drill",
    "faction": "global",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Выдать 3 случайным союзникам по 1 случайной способности"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "give_keyword:random_one_of:taunt,stealth,pierce,frenzy@ally_random|give_keyword:random_one_of:taunt,stealth,pierce,frenzy@ally_random|give_keyword:random_one_of:taunt,stealth,pierce,frenzy@ally_random",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Шесть часов теории. Шесть месяцев боя. Кто выживет — научится.»",
    "ability_text_en": {
      "order": "Give 3 random allies 1 random ability each"
    }
  },
  {
    "id": "global_act_boevoy_prizyv",
    "name_ru": "Боевой призыв",
    "name_en": "Combat Summon",
    "faction": "global",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "global_mit",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Заполнить все свободные ячейки своей стороны Бойцами G-Sec и каждому из этих призванных Бойцов +2/0/0"
    },
    "dsl_order": {
      "target": "all_empty_slots",
      "effect": "composite",
      "value": "fill_line_with_summon:global_gsec_fighter@all_empty_slots|buff_perm:2/0/0@event_subject",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Мобилизация — это когда всем повестка. Боевой призыв — когда повестка уже не нужна.»",
    "ability_text_en": {
      "order": "Fill all free slots on your side with G-Sec Troopers and give each summoned Trooper +2/0/0"
    }
  },
  {
    "id": "global_act_bronepacket",
    "name_ru": "Бронепакет Глобал",
    "name_en": "Global Armor Pack",
    "faction": "global",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Союзник получает +0/1/2"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "buff_perm",
      "value": "0/1/2",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Когда платишь корпоративную страховку — броню привозят сами.»",
    "ability_text_en": {
      "order": "An ally gets +0/1/2"
    }
  },
  {
    "id": "global_act_bronezhilet",
    "name_ru": "Бронежилет Глобал",
    "name_en": "Global Body Armor",
    "faction": "global",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_iv",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Союзник получает +0/2/2"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "buff_perm",
      "value": "0/2/2",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Двойной слой кевлара. Тройная страховка.»",
    "ability_text_en": {
      "order": "An ally gets +0/2/2"
    }
  },
  {
    "id": "global_act_evakuatsiya",
    "name_ru": "Эвакуация",
    "name_en": "Evacuation",
    "faction": "global",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "global_iv",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Союзник возвращается в руку с полностью восстановленными hp и бронёй"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "return_to_hand",
      "value": "with_full_restore_and_keep_buffs"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Снять с поля. Зашить. Зарядить. Поставить обратно.»",
    "ability_text_en": {
      "order": "An ally returns to your hand with hp and armor fully restored"
    }
  },
  {
    "id": "global_act_finalnyy_akkord",
    "name_ru": "Финальный аккорд",
    "name_en": "Final Chord",
    "faction": "global",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "global_rayna",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Нанеси 4 урона всем подавленным или молчащим вражеским юнитам"
    },
    "dsl_order": {
      "target": "enemy_suppressed_or_silenced",
      "effect": "damage",
      "value": "4"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Симфония окончена. Партитура — кладбище.»",
    "ability_text_en": {
      "order": "Deal 4 damage to all suppressed or silenced enemy units"
    }
  },
  {
    "id": "global_act_ognevoy_vyzov",
    "name_ru": "Огневой вызов",
    "name_en": "Fire Call",
    "faction": "global",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Нанеси 3 урона юниту противника"
    },
    "dsl_order": {
      "target": "enemy_choose",
      "effect": "damage",
      "value": "3"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Координаты приняты. Огонь по готовности.»",
    "ability_text_en": {
      "order": "Deal 3 damage to an enemy unit"
    }
  },
  {
    "id": "global_act_peredislokatsiya",
    "name_ru": "Передислокация",
    "name_en": "Redeployment",
    "faction": "global",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_li_pul",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Переместить союзного юнита на любую свободную ячейку своей стороны"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "move",
      "value": "any_free_cell_own_side"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Старые координаты — мусор. Новые — приказ.»",
    "ability_text_en": {
      "order": "Move an allied unit to any free slot on your side"
    }
  },
  {
    "id": "global_act_peregovory",
    "name_ru": "Переговоры",
    "name_en": "Negotiations",
    "faction": "global",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "global_li_pul",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Все юниты пропускают 1 ход. Все союзные юниты лечатся на 2 hp в этот ход"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "freeze:1@self|heal:2@ally_aoe_all"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Огонь прекращён. Контракты переподписаны. Цены подняты.»",
    "ability_text_en": {
      "order": "All units skip 1 turn. All allied units heal 2 hp this turn"
    }
  },
  {
    "id": "global_act_peregruppirovka",
    "name_ru": "Перегруппировка",
    "name_en": "Regroup",
    "faction": "global",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Переместить союзного юнита на любую свободную ячейку своей стороны"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "move",
      "value": "any_free_cell_own_side"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Не отступление. Маневр.»",
    "ability_text_en": {
      "order": "Move an allied unit to any free slot on your side"
    }
  },
  {
    "id": "global_act_podderzhka_dronov",
    "name_ru": "Поддержка дронов",
    "name_en": "Drone Support",
    "faction": "global",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "global_iv",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Все союзные юниты полностью восстанавливают hp и броню"
    },
    "dsl_order": {
      "target": "ally_aoe_all",
      "effect": "heal_to_full"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Шесть дронов. Тридцать имплантов. Никто не уходит без дозы.»",
    "ability_text_en": {
      "order": "All allied units fully restore hp and armor"
    }
  },
  {
    "id": "global_act_polevoy_gospital",
    "name_ru": "Полевой госпиталь",
    "name_en": "Field Hospital",
    "faction": "global",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_iv",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Все союзные юниты лечатся на 2 hp и призыв 1 Бойца G-Sec"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "heal:2@ally_aoe_all|summon:global_gsec_fighter@own_line"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Все живы. Все вышли. Все подпишут продление.»",
    "ability_text_en": {
      "order": "All allied units heal 2 hp and summon 1 G-Sec Trooper"
    }
  },
  {
    "id": "global_act_prokachka_snaryazheniya",
    "name_ru": "Прокачка снаряжения",
    "name_en": "Gear Upgrade",
    "faction": "global",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_mit",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Все юниты в руке и в колоде получают +1/1/0"
    },
    "dsl_order": {
      "target": "hand_and_deck",
      "effect": "buff_perm",
      "value": "1/1/0",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Подвезли. Принимай. Кто получил — тот и в строю.»",
    "ability_text_en": {
      "order": "All units in your hand and deck get +1/1/0"
    }
  },
  {
    "id": "global_act_razvyortyvanie_sektor_a",
    "name_ru": "Развёртывание Сектор-А",
    "name_en": "Sector-A Deployment",
    "faction": "global",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "global_mit",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Заполнить 1-ю линию своей стороны Бойцами G-Sec и каждому из этих Бойцов случайно выдать «Винтовка GS-7» или «Бронепакет Глобал»"
    },
    "dsl_order": {
      "target": "all_empty_line_1",
      "effect": "composite",
      "value": "fill_line_with_summon:global_gsec_fighter@all_empty_line_1|random_attach:global_act_vintovka,global_act_bronepacket@event_subject"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Сектор закрыт. Линия — наша. Враги — расходники.»",
    "ability_text_en": {
      "order": "Fill your line 1 with G-Sec Troopers and give each of them at random either «Rifle GS-7» or «Global Armor Pack»"
    }
  },
  {
    "id": "global_act_totalnaya_glushilka",
    "name_ru": "Тотальная глушилка",
    "name_en": "Total Jamming",
    "faction": "global",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "global_rayna",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Молчание на 2 хода всем вражеским юнитам на 2-й линии"
    },
    "dsl_order": {
      "target": "enemy_aoe_line_2",
      "effect": "silence",
      "duration": "2_turns"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Тыл оглох. Тыл ослеп. Тыл выживает за счёт количества.»",
    "ability_text_en": {
      "order": "Silence all enemy units on line 2 for 2 turns"
    }
  },
  {
    "id": "global_act_verbovka",
    "name_ru": "Вербовка",
    "name_en": "Recruitment",
    "faction": "global",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Призвать 2 Бойцов G-Sec на 1-ю линию"
    },
    "dsl_order": {
      "target": "all_empty_line_1",
      "effect": "summon",
      "value": "global_gsec_fighter@count:2"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Зарплата без перерывов. Контракт без чтения. Подпиши и ушёл.»",
    "ability_text_en": {
      "order": "Summon 2 G-Sec Troopers to line 1"
    }
  },
  {
    "id": "global_act_vintovka",
    "name_ru": "Винтовка GS-7",
    "name_en": "GS-7 Rifle",
    "faction": "global",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Союзник получает +2/0/0"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "buff_perm",
      "value": "2/0/0",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Старая модель. Зато работает.»",
    "ability_text_en": {
      "order": "An ally gets +2/0/0"
    }
  },
  {
    "id": "global_act_zabros",
    "name_ru": "Заброс",
    "name_en": "Insertion",
    "faction": "global",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_mit",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Призвать 3 Бойцов G-Sec на свободные ячейки своей стороны"
    },
    "dsl_order": {
      "target": "all_empty_slots",
      "effect": "summon",
      "value": "global_gsec_fighter@count:3"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Тройка с парашютами. Двое допрыгнули.»",
    "ability_text_en": {
      "order": "Summon 3 G-Sec Troopers to free slots on your side"
    }
  },
  {
    "id": "global_act_zalp_podavleniya",
    "name_ru": "Залп подавления",
    "name_en": "Suppression Volley",
    "faction": "global",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_rayna",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "1 урон всем юнитам на одной вражеской линии + Подавление-эффект на их ячейках на 2 хода"
    },
    "dsl_order": {
      "target": "enemy_aoe_line",
      "effect": "composite",
      "value": "damage:1@enemy_aoe_line|suppression_apply:line_default@enemy_aoe_line",
      "duration": "2_turns"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Залп — это не выстрелы. Залп — это сообщение.»",
    "ability_text_en": {
      "order": "1 damage to all units on one enemy line + a Suppression effect on their slots for 2 turns"
    }
  },
  {
    "id": "global_act_zaslon",
    "name_ru": "Заслон",
    "name_en": "Screen",
    "faction": "global",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_li_pul",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Союзник возвращается в руку с сохранением всех усилений"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "return_to_hand",
      "value": "keep_buffs_and_keywords"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Снят с линии. Кадровый ход.»",
    "ability_text_en": {
      "order": "An ally returns to your hand, keeping all its buffs"
    }
  },
  {
    "id": "global_avangard_boets",
    "name_ru": "Авангард-боец",
    "name_en": "Vanguard Trooper",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_iv",
    "atk": 2,
    "armor": 1,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Если ранен и на поле есть союзный хилер Глобала — лечится полностью"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "filter": "self_below_max_hp",
      "target": "self",
      "effect": "heal_to_full",
      "condition": "own_field_has_global_healer"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Пуля прошла. Хирург починил. Контракт продлили. Опять в строй.»",
    "ability_text_en": {
      "trigger": "If wounded and there is an allied Global healer on the field, heals fully"
    }
  },
  {
    "id": "global_bastion_g12",
    "name_ru": "Бастион G-12",
    "name_en": "Bastion G-12",
    "faction": "global",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 1,
    "hp": 4,
    "keywords": [
      "taunt"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Поглощает удары. Поглощает пули. Поглощает паёк за десятерых.»"
  },
  {
    "id": "global_bpla_stervyatnik4",
    "name_ru": "БПЛА Стервятник-4",
    "name_en": "Vulture-4 UAV",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 1,
    "hp": 2,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При размещении на 2-й линии получает +1/0/2"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "on_play",
      "filter": "placed_on_line_2",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "1/0/2",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Стервятники не ждут. Они находят.»",
    "ability_text_en": {
      "trigger": "When placed on line 2, gets +1/0/2"
    }
  },
  {
    "id": "global_dirizhor2_rezonans",
    "name_ru": "Дирижёр-2 «Резонанс»",
    "name_en": "Conductor-2 \"Resonance\"",
    "faction": "global",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "global_rayna",
    "atk": 4,
    "armor": 3,
    "hp": 6,
    "keywords": [
      "suppression"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Пока жив, эффект Подавления у всех союзных Глобал-юнитов применяется к двум линиям"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "has_keyword_suppression",
      "target": "ally_aoe_all",
      "effect": "suppression_extend",
      "value": "mirror_other_line_same_column"
    },
    "flavor_ru": "«Я не дирижирую один. Со мной — целый оркестр. И симфония — гибель.»",
    "ability_text_en": {
      "aura": "While alive, the Suppression effect of all allied Global units applies to both lines"
    }
  },
  {
    "id": "global_dron_bargest1",
    "name_ru": "Дрон GS-1",
    "name_en": "GS-1 Drone",
    "faction": "global",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 0,
    "hp": 2,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Глаза в небе. Уши в ваших разговорах.»"
  },
  {
    "id": "global_dron_kuryer",
    "name_ru": "Дрон-курьер",
    "name_en": "Courier Drone",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_li_pul",
    "atk": 1,
    "armor": 2,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "юниты слева и справа получают +1/1/1"
    },
    "dsl_order": {
      "target": "ally_neighbors_line",
      "effect": "buff_perm",
      "value": "1/1/1",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Доставка снаряжения. Без подписи. Без следов.»",
    "ability_text_en": {
      "order": "The units to the left and right get +1/1/1"
    }
  },
  {
    "id": "global_glushilka_gs9",
    "name_ru": "Глушилка GS-9",
    "name_en": "GS-9 Jammer",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_rayna",
    "atk": 1,
    "armor": 2,
    "hp": 4,
    "keywords": [
      "suppression"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "накладывает Молчание на 1 ход на случайного вражеского юнита"
    },
    "dsl_order": {
      "target": "enemy_random",
      "effect": "silence",
      "duration": "1_turn"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Шум. Шум. Шум. Тишина.»",
    "ability_text_en": {
      "order": "Silences a random enemy unit for 1 turn"
    }
  },
  {
    "id": "global_granater_kantao",
    "name_ru": "Гранатёр G-Sec",
    "name_en": "G-Sec Grenadier",
    "faction": "global",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 1,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "нанеси 1 урон всем юнитам на вражеской линии напротив"
    },
    "dsl_order": {
      "target": "enemy_aoe_line",
      "effect": "damage",
      "value": "1"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Один щелчок. Семь криков.»",
    "ability_text_en": {
      "order": "Deal 1 damage to all units on the opposing enemy line"
    }
  },
  {
    "id": "global_gsec_fighter",
    "name_ru": "Боец G-Sec",
    "name_en": "G-Sec Trooper",
    "faction": "global",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 0,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Стандартный комплект, стандартная зарплата. Стандартный путь до пенсии.»"
  },
  {
    "id": "global_gvardia_sektor_a",
    "name_ru": "Гвардия Сектор-А",
    "name_en": "Sector-A Guard",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 3,
    "hp": 3,
    "keywords": [
      "taunt"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Сектор А — это не район. Это статус.»"
  },
  {
    "id": "global_hirurg_gsec",
    "name_ru": "Хирург G-Sec",
    "name_en": "G-Sec Surgeon",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_iv",
    "atk": 0,
    "armor": 2,
    "hp": 5,
    "keywords": [],
    "priority_override": "healer",
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В конце хода лечит на 0/0/2 одного союзного юнита по приоритету лечения"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "target": "ally_choose_priority",
      "effect": "heal",
      "value": "2"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Сшил тебе руку. Подпиши контракт продления.»",
    "ability_text_en": {
      "trigger": "At the end of the turn, heals 0/0/2 to one allied unit by heal priority"
    }
  },
  {
    "id": "global_kapitan_gsec",
    "name_ru": "Капитан G-Sec",
    "name_en": "G-Sec Captain",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 3,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При появлении Глобал-юнита на той же линии получает +1/0/0, пока Глобал-юнит жив"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_summoned",
      "filter": "same_line",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "permanent",
      "condition": "stack_lt_3"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«За мной. Если повезёт — увидишь, куда я веду.»",
    "ability_text_en": {
      "trigger": "When a Global unit appears on the same line, gets +1/0/0 while that Global unit is alive"
    }
  },
  {
    "id": "global_komandir_feniks",
    "name_ru": "Командир «Феникс»",
    "name_en": "Commander \"Phoenix\"",
    "faction": "global",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "global_iv",
    "atk": 4,
    "armor": 3,
    "hp": 6,
    "keywords": [],
    "priority_override": "healer",
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В конце хода все союзные юниты лечатся на +0/0/2, все юниты противника получают 1 урон"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "target": "composite",
      "effect": "composite",
      "value": "heal:2@ally_aoe_all|damage:1@enemy_aoe_all"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Я не воскрешаю. Я просто не позволяю им умирать.»",
    "ability_text_en": {
      "trigger": "At the end of the turn, all allied units heal +0/0/2 and all enemy units take 1 damage"
    }
  },
  {
    "id": "global_komandir_narval",
    "name_ru": "Командир «Нарвал»",
    "name_en": "Commander \"Narwhal\"",
    "faction": "global",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "global_mit",
    "atk": 4,
    "armor": 3,
    "hp": 6,
    "keywords": [
      "pierce"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Каждый раз когда призывается союзный Боец G-Sec, он получает +1/0/2"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "card_id_global_gsec_fighter",
      "target": "event_subject",
      "effect": "buff_stats",
      "value": "1/0/2"
    },
    "flavor_ru": "«Я не выбираю — кого посылать в бой. Я выбираю — кто вернётся.»",
    "ability_text_en": {
      "aura": "Each time an allied G-Sec Trooper is summoned, it gets +1/0/2"
    }
  },
  {
    "id": "global_komandir_ognya_akkord",
    "name_ru": "Командир огня «Аккорд»",
    "name_en": "Fire Commander \"Akkord\"",
    "faction": "global",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "global_rayna",
    "atk": 2,
    "armor": 3,
    "hp": 6,
    "keywords": [
      "suppression"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Ввсе союзные Глобал-юниты с Подавлением наносят +1 урона при атаке, пока юнит на поле"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "has_keyword_suppression",
      "target": "ally_aoe_all",
      "effect": "extra_damage_on_attack",
      "value": "1"
    },
    "flavor_ru": "«Огонь — это аккорд. Аккорд — это команда. Команда — это смерть.»",
    "ability_text_en": {
      "aura": "All allied Global units with Suppression deal +1 damage on attack while this unit is on the field"
    }
  },
  {
    "id": "global_koordinator_eho",
    "name_ru": "Координатор «Эхо»",
    "name_en": "Coordinator \"Echo\"",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_iv",
    "atk": 3,
    "armor": 2,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда любой союзный юнит лечится, получает +0/0/1"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_healed",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "0/0/1",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Я слышу всех. Я отвечаю всем. Связь — моя профессия.»",
    "ability_text_en": {
      "trigger": "When any allied unit heals, gets +0/0/1"
    }
  },
  {
    "id": "global_koordinator_hronos",
    "name_ru": "Координатор «Хронос»",
    "name_en": "Coordinator \"Khronos\"",
    "faction": "global",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "global_li_pul",
    "atk": 2,
    "armor": 3,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "6 ударов по 1 урона юнитам на 2-й линии противника"
    },
    "dsl_order": {
      "target": "enemy_aoe_line_2",
      "effect": "damage",
      "value": "6_split_random_1_each"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Точное время. Точная позиция. Точные потери.»",
    "ability_text_en": {
      "order": "6 hits of 1 damage to units on the enemy's line 2"
    }
  },
  {
    "id": "global_koordinator_simfoniya",
    "name_ru": "Координатор «Симфония»",
    "name_en": "Coordinator \"Symphony\"",
    "faction": "global",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "global_rayna",
    "atk": 3,
    "armor": 3,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда подавленный или молчащий вражеский юнит умирает, юнит получает +0/1/2"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "enemy_died",
      "filter": "died_while_suppressed_or_silenced",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "0/1/2",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Каждая смерть — нота. Симфония — моя.»",
    "ability_text_en": {
      "trigger": "When a suppressed or silenced enemy unit dies, this unit gets +0/1/2"
    }
  },
  {
    "id": "global_korrektirovshchitsa_nika",
    "name_ru": "Корректировщица «Ника»",
    "name_en": "Spotter \"Nika\"",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_rayna",
    "atk": 2,
    "armor": 2,
    "hp": 3,
    "keywords": [
      "suppression"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Наносит +1 урона по подавленным/молчащим юнитам"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_attack",
      "filter": "target_is_suppressed_or_silenced",
      "target": "self",
      "effect": "extra_damage_on_attack",
      "value": "1"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Я вижу слабину. Они её только начинают чувствовать.»",
    "ability_text_en": {
      "trigger": "Deals +1 damage to suppressed/silenced units"
    }
  },
  {
    "id": "global_leytenant_sdvig",
    "name_ru": "Лейтенант «Сдвиг»",
    "name_en": "Lieutenant \"Shift\"",
    "faction": "global",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "global_li_pul",
    "atk": 3,
    "armor": 4,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда любой юнит передвигается, юнит получает +1/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "any_unit_moved",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Каждый шаг — мой шаг. Каждое движение — моя сила.»",
    "ability_text_en": {
      "trigger": "When any unit moves, this unit gets +1/0/0"
    }
  },
  {
    "id": "global_medik_yantar",
    "name_ru": "Медик «Янтарь»",
    "name_en": "Medic \"Amber\"",
    "faction": "global",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 0,
    "armor": 1,
    "hp": 3,
    "keywords": [],
    "priority_override": "healer",
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В конце своего хода: лечит на 0/0/1 один союзный юнит по приоритету лечения"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "target": "ally_choose_priority",
      "effect": "heal",
      "value": "1"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Импланты — расходник. Жизнь — тоже.»",
    "ability_text_en": {
      "trigger": "At the end of your turn: heals 0/0/1 to one allied unit by heal priority"
    }
  },
  {
    "id": "global_polevoy_shtab_kulak",
    "name_ru": "Полевой штаб «Кулак»",
    "name_en": "Field HQ \"Fist\"",
    "faction": "global",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "global_mit",
    "atk": 4,
    "armor": 2,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Пока жив, все союзные Глобал-юниты получают Подкрепление = +1 за каждого союзника на линии"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "target": "ally_aoe_all",
      "effect": "buff_stats",
      "value": "reinforcement_per_one"
    },
    "flavor_ru": "«Один кулак — десять рук. Десять рук — одна победа.»",
    "ability_text_en": {
      "aura": "While alive, all allied Global units get Reinforcement = +1 for each ally on the line"
    }
  },
  {
    "id": "global_polevoy_shtab_rokirovka",
    "name_ru": "Полевой штаб «Рокировка»",
    "name_en": "Field HQ \"Castling\"",
    "faction": "global",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "global_li_pul",
    "atk": 3,
    "armor": 2,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Пока жив, все союзные юниты на 2-й линии получают +1/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "target": "ally_aoe_line_2",
      "effect": "buff_stats",
      "value": "1/0/0"
    },
    "flavor_ru": "«Тыл — это не безопасно. Это позиция силы.»",
    "ability_text_en": {
      "aura": "While alive, all allied units on line 2 get +1/0/0"
    }
  },
  {
    "id": "global_polkovnik_bastion",
    "name_ru": "Полковник «Бастион»",
    "name_en": "Colonel \"Bastion\"",
    "faction": "global",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "global_iv",
    "atk": 3,
    "armor": 3,
    "hp": 7,
    "keywords": [
      "taunt"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При получении урона случайный союзный юнит получает +0/1/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_takes_damage",
      "filter": "self",
      "target": "ally_random",
      "effect": "heal",
      "value": "1"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Я держу удар. Они держат строй. Так и работаем.»",
    "ability_text_en": {
      "trigger": "When taking damage, a random allied unit gets +0/1/0"
    }
  },
  {
    "id": "global_pulemyot_gonchaya",
    "name_ru": "Пулемёт Гончая",
    "name_en": "Hound Machinegun",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 3,
    "armor": 1,
    "hp": 3,
    "keywords": [
      "suppression"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«400 патронов в минуту. 401-й — для тебя.»"
  },
  {
    "id": "global_razvedchik_shyopot",
    "name_ru": "Разведчик «Шёпот»",
    "name_en": "Scout \"Whisper\"",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_li_pul",
    "atk": 1,
    "armor": 1,
    "hp": 2,
    "keywords": [
      "stealth",
      "suppression"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При размещении на 2-й линии получает +0/0/2. При размещении на 1-й линии получает +2/1/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "on_play",
      "filter": "placed_on_line",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "line_dependent:line_2=0/0/2,line_1=2/1/0",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Услышал — забыл. Передал — исчез.»",
    "ability_text_en": {
      "trigger": "When placed on line 2, gets +0/0/2. When placed on line 1, gets +2/1/0"
    }
  },
  {
    "id": "global_saper_onix",
    "name_ru": "Сапёр Оникс",
    "name_en": "Sapper Onyx",
    "faction": "global",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 1,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "выбранный юнит теряет 0/1/0"
    },
    "dsl_order": {
      "target": "enemy_choose",
      "effect": "armor_break",
      "value": "1"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Ваша броня — мой подарок. Распакуй.»",
    "ability_text_en": {
      "order": "A chosen unit loses 0/1/0"
    }
  },
  {
    "id": "global_saper_podavitel_kladovshchik",
    "name_ru": "Сапёр-подавитель «Кладовщик»",
    "name_en": "Sapper-Suppressor \"Storer\"",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_rayna",
    "atk": 1,
    "armor": 2,
    "hp": 3,
    "keywords": [
      "suppression"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "вражеский юнит на той же ячейке теряет -0/2/0"
    },
    "dsl_order": {
      "target": "opposite_unit_same_cell",
      "effect": "armor_break",
      "value": "2"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Складировал шесть мин. Доставил пять. Шестая — сюрприз.»",
    "ability_text_en": {
      "order": "The enemy unit on the same slot loses 0/2/0"
    }
  },
  {
    "id": "global_serzhant_grif",
    "name_ru": "Сержант «Гриф»",
    "name_en": "Sergeant \"Grif\"",
    "faction": "global",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "global_mit",
    "atk": 3,
    "armor": 3,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При выставлении Бойца G-Sec: ему +1/0/1, Грифу +1/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_summoned",
      "filter": "card_id_global_gsec_fighter",
      "target": "composite",
      "effect": "composite",
      "value": "buff_perm:1/0/1@event_subject|buff_self_perm:1/0/0@self",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Я не учу. Я отбираю выживших.»",
    "ability_text_en": {
      "trigger": "When a G-Sec Trooper is deployed: it gets +1/0/1, Grif gets +1/0/0"
    }
  },
  {
    "id": "global_snayper_lyutyi",
    "name_ru": "Снайпер «Лютый»",
    "name_en": "Sniper \"Lyuty\"",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 3,
    "armor": 0,
    "hp": 2,
    "keywords": [
      "stealth",
      "pierce",
      "suppression"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Один выстрел. Один контракт. Никаких свидетелей.»"
  },
  {
    "id": "global_snayperskiy_raschet_tor",
    "name_ru": "Снайперский расчёт «Тор»",
    "name_en": "Sniper Crew \"Thor\"",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_rayna",
    "atk": 3,
    "armor": 2,
    "hp": 2,
    "keywords": [
      "stealth",
      "suppression"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Двое. Один снимает. Второй слушает. Третьего не было.»"
  },
  {
    "id": "global_starshina_zubr",
    "name_ru": "Старшина «Зубр»",
    "name_en": "Sergeant \"Zubr\"",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_mit",
    "atk": 3,
    "armor": 2,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда выставляется союзный Боец G-Sec получает +1/0/1, но не более 3 раз"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_summoned",
      "filter": "card_id_global_gsec_fighter",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "1/0/1",
      "duration": "permanent",
      "condition": "stack_lt_3"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Каждый новобранец — пара рук. Каждая пара рук — пара глаз. Хорошее зрение спасает жизнь.»",
    "ability_text_en": {
      "trigger": "When an allied G-Sec Trooper is deployed, gets +1/0/1, but no more than 3 times"
    }
  },
  {
    "id": "global_starshiy_medik_kardinal",
    "name_ru": "Старший медик «Кардинал»",
    "name_en": "Senior Medic \"Cardinal\"",
    "faction": "global",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "global_iv",
    "atk": 2,
    "armor": 3,
    "hp": 5,
    "keywords": [],
    "priority_override": "healer",
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Пока жив, все союзники на 1-й линии получают +0/0/1 в конце хода"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "turn_end",
      "target": "ally_aoe_line_1",
      "effect": "heal",
      "value": "1"
    },
    "flavor_ru": "«У него восемнадцать имплантов и две лицензии. Самые дешёвые — медицинские.»",
    "ability_text_en": {
      "aura": "While alive, all allies on line 1 get +0/0/1 at the end of the turn"
    }
  },
  {
    "id": "global_strateg_gambit",
    "name_ru": "Стратег «Гамбит»",
    "name_en": "Strategist \"Gambit\"",
    "faction": "global",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "global_li_pul",
    "atk": 4,
    "armor": 3,
    "hp": 6,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В конце хода если на 1-й линии противника 2+ юнитов — все они получают 2 урона"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "target": "enemy_aoe_line_1_if_2plus",
      "effect": "damage",
      "value": "2",
      "condition": "enemy_line_1_has_2plus_units"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Фигуры расставлены. Очередь не моя — но партия моя.»",
    "ability_text_en": {
      "trigger": "At the end of the turn, if there are 2+ units on the enemy's line 1, they all take 2 damage"
    }
  },
  {
    "id": "global_strelok_kobra",
    "name_ru": "Стрелок Кобра",
    "name_en": "Cobra Rifleman",
    "faction": "global",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 0,
    "hp": 2,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Винтовка GSec-7. Прицел Дальзор-3. Глаз — свой.»"
  },
  {
    "id": "global_taktik_yozh",
    "name_ru": "Тактик «Ёж»",
    "name_en": "Tactician \"Hedgehog\"",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_li_pul",
    "atk": 2,
    "armor": 2,
    "hp": 4,
    "keywords": [
      "suppression"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда любой юнит передвигается, получает +1/0/0 до конца хода"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "any_unit_moved",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "until_end_of_turn",
      "condition": "stack_lt_3"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Иголки везде. Особенно там, где не ждёшь.»",
    "ability_text_en": {
      "trigger": "When any unit moves, gets +1/0/0 until end of turn"
    }
  },
  {
    "id": "global_uchebka_gsec",
    "name_ru": "Учебка G-Sec",
    "name_en": "G-Sec Bootcamp",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_mit",
    "atk": 1,
    "armor": 4,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В конце хода: призывает Бойца G-Sec на свободную ячейку любой своей линии"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "target": "own_line",
      "effect": "summon",
      "value": "global_gsec_fighter@any_free_cell"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Шесть недель. Сорок патронов на стрелка. Один выпускник из десяти.»",
    "ability_text_en": {
      "trigger": "At the end of the turn: summons a G-Sec Trooper to a free slot on any of your lines"
    }
  },
  {
    "id": "global_znamya_bastion",
    "name_ru": "Знамя «Бастион»",
    "name_en": "Banner \"Bastion\"",
    "faction": "global",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "global_mit",
    "atk": 2,
    "armor": 1,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Все союзные Бойцы G-Sec получают +1/0/0 пока юнит на поле"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "card_id_global_gsec_fighter",
      "target": "ally_aoe_all",
      "effect": "buff_stats",
      "value": "1/0/0"
    },
    "flavor_ru": "«Один флаг на всех. Один контракт на каждого. Двенадцать пуль — на всякий случай.»",
    "ability_text_en": {
      "aura": "All allied G-Sec Troopers get +1/0/0 while this unit is on the field"
    }
  }
];
